/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  BookableSlot,
  BookingDetails,
  BookingFormDetails,
  BookingFormStatus,
  BookingFormUpsertRequest,
  PlaceBookingRequest,
  SuggestTimeRequest,
} from '../../models/bookings/v3-booking.model';
import { CursorPage } from '../../models/page';
import { ObservableResult } from '../../store';
import { V3BookingDataService } from './v3-booking-data.service';

@Injectable()
export class MockV3BookingDataService implements V3BookingDataService {
  getEmbeddableForms(): ObservableResult<BookingFormDetails[]> {
    return ObservableResult.ofSuccess();
  }

  getFormsByUids(uids: string[]): ObservableResult<BookingFormDetails[]> {
    return ObservableResult.ofSuccess();
  }

  createForm(request: BookingFormUpsertRequest): ObservableResult<BookingFormDetails> {
    return ObservableResult.ofSuccess();
  }

  updateForm(bookingFormUid: string, request: BookingFormUpsertRequest): ObservableResult<BookingFormDetails> {
    return ObservableResult.ofSuccess();
  }

  deleteForm(bookingFormUid: string): ObservableResult<boolean> {
    return ObservableResult.ofSuccess();
  }

  changeFormStatus(bookingFormUid: string, status: BookingFormStatus): ObservableResult<BookingFormDetails> {
    return ObservableResult.ofSuccess();
  }

  getHostedBookings(from: string, to: string): ObservableResult<CursorPage<BookingDetails>> {
    return ObservableResult.ofSuccess();
  }

  getMyBookings(from: string, to: string): ObservableResult<CursorPage<BookingDetails>> {
    return ObservableResult.ofSuccess();
  }

  getPendingRequests(): ObservableResult<BookingDetails[]> {
    return ObservableResult.ofSuccess();
  }

  getMyForms(): ObservableResult<BookingFormDetails[]> {
    return ObservableResult.ofSuccess();
  }

  getBooking(bookingUid: string): ObservableResult<BookingDetails> {
    return ObservableResult.ofSuccess();
  }

  getBookingIcs(bookingUid: string): Observable<string> {
    return of('');
  }

  getSlots(bookingFormUid: string, from: string, to: string): ObservableResult<BookableSlot[]> {
    return ObservableResult.ofSuccess();
  }

  placeBooking(bookingFormUid: string, request: PlaceBookingRequest): ObservableResult<BookingDetails> {
    return ObservableResult.ofSuccess();
  }

  acceptBooking(bookingUid: string): ObservableResult<BookingDetails> {
    return ObservableResult.ofSuccess();
  }

  declineBooking(bookingUid: string, reason?: string): ObservableResult<BookingDetails> {
    return ObservableResult.ofSuccess();
  }

  reschedule(bookingUid: string, request: SuggestTimeRequest): ObservableResult<BookingDetails> {
    return ObservableResult.ofSuccess();
  }

  suggestTime(bookingUid: string, request: SuggestTimeRequest): ObservableResult<BookingDetails> {
    return ObservableResult.ofSuccess();
  }

  claimBooking(bookingUid: string): ObservableResult<BookingDetails> {
    return ObservableResult.ofSuccess();
  }

  cancelBooking(bookingUid: string): ObservableResult<BookingDetails> {
    return ObservableResult.ofSuccess();
  }
}
